import { render, staticRenderFns } from "./bankAccount.vue?vue&type=template&id=63bba96e"
import script from "./bankAccount.vue?vue&type=script&lang=js"
export * from "./bankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports